import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#7A7369]" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && user.role !== role) {
    // Send each role to ITS own home, never to a shared /dashboard that re-resolves.
    // Super admins should NOT silently land on /admin when they click an institute/student URL
    // — that hides the fact that they have no business being there.
    const home = (
      user.role === "super_admin" ? "/admin" :
      user.role === "institute_admin" ? "/institute" :
      user.role === "self_study_student" ? "/selfstudy" :
      user.role === "student" ? "/student" : "/"
    );
    return <Navigate to={home} replace />;
  }
  return children;
}
